import { configureStore } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import { toIntlLocale } from '../helpers/lang';

import createRootReducer from './rootReducer';

interface Arg {
  lang?: string;
  initialState?: any;
}

// Use inferred return type for making correctly Redux types
const createStore = ({ lang, initialState }: Arg = {}) => {
  if (lang) {
    const intlLocale = toIntlLocale(lang);
    dayjs.locale(intlLocale === 'zh' ? 'zh-cn' : intlLocale);
  }

  const store = configureStore({
    preloadedState: initialState,
    reducer: createRootReducer,
    devTools: __DEV__,
  });

  return { store };
};

export default createStore;
